class MonadicError extends Error{constructor(m,p,e,a,c){super(m);this.name='MonadicError';this.path=p;this.expected=e;this.actual=a;this.callStack=c}};
function typeError(p,e,v){const a=v===null?'null':typeof v;const err=new MonadicError('Expected '+e+" for '"+p+"', got "+a,p,e,a);const c=globalThis.__tjs?.getConfig?.();if(c?.logTypeErrors)console.error('[TJS TypeError] '+err.message);if(c?.throwTypeErrors)throw err;return err};
function isMonadicError(v){return v instanceof Error&&v.name==='MonadicError'&&'path' in v};
const __stack=[];function pushStack(n){__stack.push(n)}function popStack(){__stack.pop()}function getStack(){return[...__stack]};
function Type(d,p,e){const t={description:d,__runtimeType:true};if(typeof p==='function'){t.check=p;t.default=e??null}else{const ex=e??p;t.default=ex;t.check=v=>{if(ex===null)return true;return typeof v===typeof ex}}return t};
const __tjs = globalThis.__tjs?.createRuntime?.() ?? {typeError,isMonadicError,pushStack,popStack,getStack,Type};
/* tjs <- by-path.ts */

import { XinObject, XinArray, XinScalar } from './xin-types'

import { makeError } from './make-error'

/* line 6 */
function now36() {
    return new Date(parseInt('1000000000', 36) + Date.now())
        .valueOf()
        .toString(36)
        .slice(1);
}
now36.__tjs = {
  "params": {},
  "returns": {
    "type": {
      "kind": "string"
    }
  },
  "unsafeReturn": true,
  "source": "by-path.ts:6"
}

let _seq = 0;

/* line 12 */
function seq() {
    return (parseInt('10000', 36) + ++_seq).toString(36).slice(-5);
}
seq.__tjs = {
  "params": {},
  "returns": {
    "type": {
      "kind": "string"
    }
  },
  "unsafeReturn": true,
  "source": "by-path.ts:12"
}

/* line 14 */
export function id() {
    return now36() + seq();
}
id.__tjs = {
  "params": {},
  "returns": {
    "type": {
      "kind": "string"
    }
  },
  "unsafeReturn": true,
  "source": "by-path.ts:23"
}

const _delete_ = Symbol('delete');

const _newObject_ = Symbol('new-object');

const _auto_ = Symbol('automatic-index');

const Part = Type('Part', undefined, '')

const PartArray = Type('PartArray', undefined, [null])

/* line 23 */
function pathParts(path) {
  try {
  __tjs.pushStack('by-path.ts:23:pathParts');
  if (path instanceof Error) return path;
  if ((typeof path !== 'string' && !Array.isArray(path))) return __tjs.typeError('by-path.ts:23:pathParts.path', 'string | array', path);

    if (path === '') {
        return [];
    }
    if (Array.isArray(path)) {
        return path;
    }
    else {
        const parts = [];
        while (path.length > 0) {
            let index = path.search(/\[[^\]]+\]/);
            if (index === -1) {
                parts.push(path.split('.'));
                break;
            }
            else {
                const part = path.slice(0, index);
                path = path.slice(index);
                if (part !== '') {
                    parts.push(part.split('.'));
                }
                index = path.indexOf(']') + 1;
                parts.push(path.slice(1, index - 1));
                // handle paths dereferencing array element like foo[0].id
                if (path.slice(index, index + 1) === '.') {
                    index += 1;
                }
                path = path.slice(index);
            }
        }
        return parts;
    }

  } finally { __tjs.popStack(); }
}
pathParts.__tjs = {
  "params": {
    "path": {
      "type": {
        "kind": "union",
        "members": [
          {
            "kind": "string"
          },
          {
            "kind": "array",
            "items": {
              "kind": "null"
            }
          }
        ]
      },
      "required": true,
      "default": null
    }
  },
  "returns": {
    "type": {
      "kind": "array",
      "items": {
        "kind": "null"
      }
    }
  },
  "unsafeReturn": true,
  "source": "by-path.ts:23"
}

const idPathMaps = new WeakMap();

const IdPathMap = Type('IdPathMap')

/* line 62 */
function buildIdPathValueMap(array,idPath) {
  try {
  __tjs.pushStack('by-path.ts:62:buildIdPathValueMap');
  if (array instanceof Error) return array;
  if (idPath instanceof Error) return idPath;
  if (!Array.isArray(array)) return __tjs.typeError('by-path.ts:62:buildIdPathValueMap.array', 'array', array);
  if (typeof idPath !== 'string') return __tjs.typeError('by-path.ts:62:buildIdPathValueMap.idPath', 'string', idPath);

    if (idPathMaps.get(array) === undefined) {
        idPathMaps.set(array, {});
    }
    if (idPathMaps.get(array)[idPath] === undefined) {
        idPathMaps.get(array)[idPath] = {};
    }
    const map = idPathMaps.get(array)[idPath];
    if (idPath === '_auto_') {
        array.forEach((item, idx) => {
            if (item[_auto_] === undefined)
                item[_auto_] = id();
            map[item[_auto_] + ''] = idx;
        });
    }
    else {
        array.forEach((item, idx) => {
            map[getByPath(item, idPath) + ''] = idx;
        });
    }
    return map;

  } finally { __tjs.popStack(); }
}
buildIdPathValueMap.__tjs = {
  "params": {
    "array": {
      "type": {
        "kind": "array",
        "items": {
          "kind": "null"
        }
      },
      "required": true,
      "default": null
    },
    "idPath": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    }
  },
  "returns": {
    "type": {
      "kind": "object",
      "shape": {}
    }
  },
  "unsafeReturn": true,
  "source": "by-path.ts:62"
}

/* line 84 */
function getIdPathMap(array,idPath) {
  try {
  __tjs.pushStack('by-path.ts:84:getIdPathMap');
  if (array instanceof Error) return array;
  if (idPath instanceof Error) return idPath;
  if (!Array.isArray(array)) return __tjs.typeError('by-path.ts:84:getIdPathMap.array', 'array', array);
  if (typeof idPath !== 'string') return __tjs.typeError('by-path.ts:84:getIdPathMap.idPath', 'string', idPath);

    if (idPathMaps.get(array) === undefined ||
        idPathMaps.get(array)[idPath] === undefined) {
        return buildIdPathValueMap(array, idPath);
    }
    else {
        return idPathMaps.get(array)[idPath];
    }

  } finally { __tjs.popStack(); }
}
getIdPathMap.__tjs = {
  "params": {
    "array": {
      "type": {
        "kind": "array",
        "items": {
          "kind": "null"
        }
      },
      "required": true,
      "default": null
    },
    "idPath": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    }
  },
  "returns": {
    "type": {
      "kind": "object",
      "shape": {}
    }
  },
  "unsafeReturn": true,
  "source": "by-path.ts:84"
}

/* line 95 */
function keyToIndex(array,idPath, idValue) {
  try {
  __tjs.pushStack('by-path.ts:95:keyToIndex');
  if (array instanceof Error) return array;
  if (idPath instanceof Error) return idPath;
  if (idValue instanceof Error) return idValue;
  if (!Array.isArray(array)) return __tjs.typeError('by-path.ts:95:keyToIndex.array', 'array', array);
  if (typeof idPath !== 'string') return __tjs.typeError('by-path.ts:95:keyToIndex.idPath', 'string', idPath);

    idValue = idValue + '';
    let idx = getIdPathMap(array, idPath)[idValue];
    if (idx === undefined ||
        getByPath(array[idx], idPath) + '' !== idValue) {
        idx = buildIdPathValueMap(array, idPath)[idValue];
    }
    return idx;

  } finally { __tjs.popStack(); }
}
keyToIndex.__tjs = {
  "params": {
    "array": {
      "type": {
        "kind": "array",
        "items": {
          "kind": "null"
        }
      },
      "required": true,
      "default": null
    },
    "idPath": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    },
    "idValue": {
      "type": {
        "kind": "any"
      },
      "required": true
    }
  },
  "returns": {
    "type": {
      "kind": "number"
    }
  },
  "unsafeReturn": true,
  "source": "by-path.ts:95"
}

/* line 107 */
/* TODO: TS types degraded — obj: XinObject */
function byKey(obj,key, valueToInsert) {
  try {
  __tjs.pushStack('by-path.ts:124:byKey');
  if (obj instanceof Error) return obj;
  if (key instanceof Error) return key;
  if (valueToInsert instanceof Error) return valueToInsert;
  if (typeof key !== 'string') return __tjs.typeError('by-path.ts:124:byKey.key', 'string', key);

    if (obj[key] === undefined && valueToInsert !== undefined) {
        obj[key] = valueToInsert;
    }
    return obj[key];

  } finally { __tjs.popStack(); }
}
byKey.__tjs = {
  "params": {
    "obj": {
      "type": {
        "kind": "any"
      },
      "required": false
    },
    "key": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    },
    "valueToInsert": {
      "type": {
        "kind": "any"
      },
      "required": false
    }
  },
  "source": "by-path.ts:124"
}

/* line 114 */
/* TODO: TS types degraded — array: any[] | XinObject */
function byIdPath(array,idPath,idValue, valueToInsert) {
  try {
  __tjs.pushStack('by-path.ts:133:byIdPath');
  if (array instanceof Error) return array;
  if (idPath instanceof Error) return idPath;
  if (idValue instanceof Error) return idValue;
  if (valueToInsert instanceof Error) return valueToInsert;
  if (typeof idPath !== 'string') return __tjs.typeError('by-path.ts:133:byIdPath.idPath', 'string', idPath);
  if (typeof idValue !== 'string') return __tjs.typeError('by-path.ts:133:byIdPath.idValue', 'string', idValue);

    let idx = idPath !== '' ? keyToIndex(array, idPath, idValue) : idValue;
    if (valueToInsert === _delete_) {
        array.splice(idx, 1);
        idPathMaps.delete(array);
        return Symbol('deleted');
    }
    else if (valueToInsert === _newObject_) {
        if (idPath === '' && array[idx] === undefined) {
            array[idx] = {};
        }
    }
    else if (valueToInsert !== undefined) {
        if (idx !== undefined) {
            array[idx] = valueToInsert;
        }
        else if (idPath !== '' &&
            getByPath(valueToInsert, idPath) + '' === idValue + '') {
            array.push(valueToInsert);
            idx = array.length - 1;
        }
        else {
            throw new Error(`byIdPath insert failed at [${idPath}=${idValue}]`);
        }
    }
    return array[idx];

  } finally { __tjs.popStack(); }
}
byIdPath.__tjs = {
  "params": {
    "array": {
      "type": {
        "kind": "any"
      },
      "required": true
    },
    "idPath": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    },
    "idValue": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    },
    "valueToInsert": {
      "type": {
        "kind": "any"
      },
      "required": false
    }
  },
  "source": "by-path.ts:133"
}

/* line 145 */
function expectArray(obj) {
  try {
  __tjs.pushStack('by-path.ts:145:expectArray');
  if (obj instanceof Error) return obj;

    if (!Array.isArray(obj)) {
        throw makeError('setByPath failed: expected array, found', obj);
    }

  } finally { __tjs.popStack(); }
}
expectArray.__tjs = {
  "params": {
    "obj": {
      "type": {
        "kind": "any"
      },
      "required": false
    }
  },
  "source": "by-path.ts:145"
}

/* line 151 */
function expectObject(obj) {
  try {
  __tjs.pushStack('by-path.ts:151:expectObject');
  if (obj instanceof Error) return obj;

    if (obj == null || !(obj instanceof Object)) {
        throw makeError('setByPath failed: expected Object, found', obj);
    }

  } finally { __tjs.popStack(); }
}
expectObject.__tjs = {
  "params": {
    "obj": {
      "type": {
        "kind": "any"
      },
      "required": false
    }
  },
  "source": "by-path.ts:151"
}

/* line 157 */
/* TODO: TS types degraded — obj: XinObject | XinArray */
function getByPath(obj,path) {
  try {
  __tjs.pushStack('by-path.ts:177:getByPath');
  if (obj instanceof Error) return obj;
  if (path instanceof Error) return path;
  if (typeof path !== 'string') return __tjs.typeError('by-path.ts:177:getByPath.path', 'string', path);

    const parts = pathParts(path);
    let found = obj;
    let i, iMax, j, jMax;
    for (i = 0, iMax = parts.length; found !== undefined && i < iMax; i++) {
        const part = parts[i];
        if (Array.isArray(part)) {
            for (j = 0, jMax = part.length; found !== undefined && j < jMax; j++) {
                const key = part[j];
                found = found[key];
            }
        }
        else {
            if (found.length === 0) {
                found = found[Number(part.slice(1))];
                if (part[0] !== '=') {
                    return undefined;
                }
            }
            else if (part.includes('=')) {
                const [idPath, ...tail] = part.split('=');
                found = byIdPath(found, idPath, tail.join('='));
            }
            else {
                j = parseInt(part, 10);
                found = found[j];
            }
        }
    }
    return found;

  } finally { __tjs.popStack(); }
}
getByPath.__tjs = {
  "params": {
    "obj": {
      "type": {
        "kind": "any"
      },
      "required": false
    },
    "path": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    }
  },
  "source": "by-path.ts:177"
}

/* line 186 */
/* TODO: TS types degraded — orig: XinObject | XinArray */
function setByPath(orig,path, val) {
  try {
  __tjs.pushStack('by-path.ts:211:setByPath');
  if (orig instanceof Error) return orig;
  if (path instanceof Error) return path;
  if (val instanceof Error) return val;
  if (typeof path !== 'string') return __tjs.typeError('by-path.ts:211:setByPath.path', 'string', path);

    let obj = orig;
    if (path === '')
        throw new Error('setByPath cannot be used to set the root object');
    const parts = pathParts(path);
    while (obj != null && parts.length > 0) {
        const part = parts.shift();
        if (typeof part === 'string') {
            const equalsOffset = part.indexOf('=');
            if (equalsOffset > -1) {
                if (equalsOffset === 0) {
                    expectObject(obj);
                }
                else {
                    expectArray(obj);
                }
                const idPath = part.slice(0, equalsOffset);
                const idValue = part.slice(equalsOffset + 1);
                obj = byIdPath(obj, idPath, idValue, parts.length > 0 ? _newObject_ : val);
                if (parts.length === 0) {
                    return true;
                }
            }
            else {
                expectArray(obj);
                const idx = parseInt(part, 10);
                if (parts.length > 0) {
                    obj = obj[idx];
                }
                else {
                    if (val !== _delete_) {
                        if (obj[idx] === val) {
                            return false;
                        }
                        obj[idx] = val;
                    }
                    else {
                        obj.splice(idx, 1);
                    }
                    return true;
                }
            }
        }
        else if (Array.isArray(part) && part.length > 0) {
            expectObject(obj);
            while (part.length > 0) {
                const key = part.shift();
                if (part.length > 0 || parts.length > 0) {
                    // if we're at the end of part.length then we need to insert an array
                    obj = byKey(obj, key, part.length > 0 ? {} : []);
                }
                else {
                    if (val !== _delete_) {
                        if (obj[key] === val) {
                            return false;
                        }
                        obj[key] = val;
                    }
                    else {
                        if (!Object.prototype.hasOwnProperty.call(obj, key)) {
                            return false;
                        }
                        delete obj[key];
                    }
                    return true;
                }
            }
        }
        else {
            throw new Error(`setByPath failed, bad path ${path}`);
        }
    }
    throw new Error(`setByPath(${orig}, ${path}, ${val}) failed`);

  } finally { __tjs.popStack(); }
}
setByPath.__tjs = {
  "params": {
    "orig": {
      "type": {
        "kind": "any"
      },
      "required": false
    },
    "path": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    },
    "val": {
      "type": {
        "kind": "any"
      },
      "required": false
    }
  },
  "returns": {
    "type": {
      "kind": "boolean"
    }
  },
  "unsafeReturn": true,
  "source": "by-path.ts:211"
}

/* line 264 */
/* TODO: TS types degraded — orig: XinObject */
function deleteByPath(orig,path) {
  try {
  __tjs.pushStack('by-path.ts:288:deleteByPath');
  if (orig instanceof Error) return orig;
  if (path instanceof Error) return path;
  if (typeof path !== 'string') return __tjs.typeError('by-path.ts:288:deleteByPath.path', 'string', path);

    if (getByPath(orig, path) !== null) {
        setByPath(orig, path, _delete_);
    }

  } finally { __tjs.popStack(); }
}
deleteByPath.__tjs = {
  "params": {
    "orig": {
      "type": {
        "kind": "any"
      },
      "required": false
    },
    "path": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    }
  },
  "source": "by-path.ts:288"
}

export { getByPath, setByPath, deleteByPath, pathParts };